import React from 'react';
import { Role } from '../../@types/auth';
import { useNavItemVisibility } from './useNavItemVisibility';

interface Props {
    requiredRoles: Role[];
    navTitle: string;
    children: React.ReactNode;
}

export const NavItemRouteGuard: React.FC<Props> = ({ requiredRoles, navTitle, children }) => {
    const isVisible = useNavItemVisibility(requiredRoles, navTitle);

    return isVisible ? <>{children}</> : null;
};
